import styled from 'styled-components';
import { TextField, Button } from '@material-ui/core';

export const Container = styled.div`
  min-height: 100vh;
  background: #22467d;
  display: flex;
  flex-direction: column;
  justify-content: flex-start;
  align-items: center;
  padding: 20px;
`;

export const Content = styled.div`
  width: 100%;
  max-width: 600px;
  display: flex;
  flex-direction: column;
  gap: 20px;
`;

export const Header = styled.div`
  width: 100%;
  max-width: 1200px;
  display: flex;
  align-items: center;
  justify-content: center;
  padding: 20px;
  margin-bottom: 30px;
`;

export const HeaderContent = styled.div`
  display: flex;
  flex-direction: column;
  align-items: center;
  gap: 15px;
`;

export const Logo = styled.img`
  height: 60px;
  background: transparent;
  mix-blend-mode: normal;
`;

export const Title = styled.h1`
  color: #fff;
  margin: 0;
  font-size: 1.8rem;
  font-weight: 700;
  text-align: center;
`;

export const Subtitle = styled.p`
  color: #fff;
  margin: 5px 0 0 0;
  font-size: 0.9rem;
  text-align: center;
  opacity: 0.9;
`;

export const Card = styled.div`
  background: #fff;
  border-radius: 12px;
  padding: 25px;
  box-shadow: 0 4px 6px rgba(0, 0, 0, 0.1);
`;

export const SectionTitle = styled.h3`
  color: #122d58;
  margin: 0 0 20px 0;
  font-size: 1.1rem;
  font-weight: 700;
  text-transform: uppercase;
  display: flex;
  align-items: center;
  padding-left: 15px;
  border-left: 4px solid #122d58;
`;

export const InfoCardGrid = styled.div`
  display: grid;
  grid-template-columns: repeat(auto-fit, minmax(140px, 1fr));
  gap: 15px;
  margin-top: 20px;
`;

export const InfoCard = styled.div`
  background: #fff;
  border: 1px solid #e0e0e0;
  border-radius: 8px;
  padding: 15px;
  display: flex;
  flex-direction: column;
  align-items: center;
  text-align: center;
  min-height: 100px;
  justify-content: center;
`;

export const InfoIcon = styled.div`
  color: #122d58;
  margin-bottom: 10px;
  display: flex;
  align-items: center;
  justify-content: center;
`;

export const InfoCardContent = styled.div`
  display: flex;
  flex-direction: column;
  gap: 5px;
  width: 100%;
`;

export const InfoLabel = styled.span`
  font-weight: 600;
  color: #666;
  font-size: 0.75rem;
  text-transform: uppercase;
  letter-spacing: 0.5px;
`;

export const InfoValue = styled.span`
  color: #122d58;
  font-size: 0.9rem;
  font-weight: 500;
  word-break: break-word;
`;

export const CodeInput = styled(TextField)`
  && {
    .MuiOutlinedInput-root {
      font-size: 1.5rem;
      letter-spacing: 0.5rem;
      text-align: center;
      font-weight: 600;
    }
  }
`;

export const PinCodeContainer = styled.div`
  display: flex;
  justify-content: center;
  align-items: center;
  gap: 15px;
  margin: 30px 0;
  width: 100%;
`;

export const PinCodeInput = styled.input`
  width: 60px;
  height: 70px;
  border: none;
  border-bottom: 3px solid ${props => props.hasError ? '#f44336' : props.filled ? '#122d58' : '#ccc'};
  background: transparent;
  text-align: center;
  font-size: 2rem;
  font-weight: 700;
  color: #122d58;
  outline: none;
  transition: border-color 0.3s ease;
  
  &:focus {
    border-bottom-color: #122d58;
  }
  
  &::placeholder {
    color: transparent;
  }
  
  &::-webkit-outer-spin-button,
  &::-webkit-inner-spin-button {
    -webkit-appearance: none;
    margin: 0;
  }
  
  &[type=number] {
    -moz-appearance: textfield;
  }
`;

export const PinCodeError = styled.div`
  color: #f44336;
  font-size: 0.875rem;
  margin-top: 10px;
  text-align: center;
  width: 100%;
`;

export const ButtonContainer = styled.div`
  display: flex;
  justify-content: center;
  width: 100%;
  margin-top: 20px;
`;

export const StartButton = styled(Button)`
  && {
    background: linear-gradient(135deg, #122d58 0%, #1a3d6b 100%);
    color: #fff;
    font-weight: 700;
    font-size: 1rem;
    padding: 14px 40px;
    border-radius: 8px;
    text-transform: uppercase;
    box-shadow: 0 4px 6px rgba(18, 45, 88, 0.3);
    
    &:hover {
      background: linear-gradient(135deg, #1a3d6b 0%, #122d58 100%);
    }
    
    &:disabled {
      background: #ccc;
      color: #666;
    }
  }
`;

export const StatusButton = styled(Button)`
  && {
    background: #e3f2fd;
    color: #122d58;
    font-weight: 600;
    font-size: 0.9rem;
    padding: 10px 20px;
    border-radius: 8px;
    margin-top: 15px;
    width: 100%;
    text-transform: none;
    
    &:hover {
      background: #bbdefb;
    }
  }
`;

export const LoadingContainer = styled.div`
  display: flex;
  flex-direction: column;
  align-items: center;
  justify-content: center;
  min-height: 100vh;
  color: #fff;

  p {
    margin-top: 20px;
    font-size: 1.1rem;
  }
`;

